import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  centeredContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
    maxWidth: "60rem",
  },
  qrcode: {
    background: "white",
    padding: "1rem",
    borderRadius: "0.5rem",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    marginBottom: "1rem",
    [theme.breakpoints.down('sm')]: {
      padding: "0.75rem",
      marginBottom: "0.75rem",
    },
  },
  typeContainer: {
    textAlign: "left",
    marginBottom: "1rem",
    width: "100%",
    maxWidth: "25rem",
    padding: "0.5rem 0",
    borderBottom: "1px solid #e0e0e0",
    [theme.breakpoints.down('sm')]: {
      maxWidth: "100%",
      marginBottom: "0.75rem",
    },
  },
  typeContainerNoMarginBottom: {
    marginBottom: 0,
  },
  typeContainerNoMarginTop: {
    marginTop: 0,
  },
  typeLabel: {
    fontSize: "0.875rem",
    fontWeight: "bold",
    color: theme.palette.primary.main,
    textTransform: "uppercase",
    letterSpacing: "0.025rem",
    display: "inline-block",
    marginRight: "0.5rem",
  },
  typeValue: {
    fontSize: "1.125rem",
    fontWeight: "bold",
    color: theme.palette.primary.main,
    display: "inline-block",
    [theme.breakpoints.down('sm')]: {
      fontSize: "1rem",
    },
  },
  datesRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    maxWidth: "48rem",
    marginBottom: "0.25rem",
    padding: "0.5rem 6rem",
    gap: "2rem",
    [theme.breakpoints.down('sm')]: {
      maxWidth: "100%",
      flexDirection: "column",
      alignItems: "flex-start",
      padding: "0.25rem 3rem",
      gap: "0rem",
      marginBottom: "0.125rem",
    },
  },
  validFromContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      marginBottom: "1rem",
    },
  },
  validToContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      alignItems: "flex-start",
    },
  },
  nameRoomRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    maxWidth: "48rem",
    padding: "0.5rem 6rem",
    gap: "2rem",
    [theme.breakpoints.down('sm')]: {
      maxWidth: "100%",
      flexDirection: "column",
      alignItems: "flex-start",
      padding: "0.25rem 3rem",
      gap: "0rem",
    },
  },
  nameContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      marginBottom: "1rem",
    },
  },
  roomContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      alignItems: "flex-start",
    },
  },
  fieldLabel: {
    fontSize: "0.875rem",
    fontWeight: "bold",
    color: theme.palette.primary.main,
    marginBottom: "0.25rem",
    textTransform: "uppercase",
    letterSpacing: "0.025rem",
    [theme.breakpoints.down('sm')]: {
      fontSize: "0.8rem",
      marginBottom: "0.1875rem",
    },
  },
  fieldValue: {
    fontSize: "1.125rem",
    fontWeight: "normal",
    color: theme.palette.primary.main,
    lineHeight: "1.4",
    whiteSpace: "nowrap",
    [theme.breakpoints.down('sm')]: {
      fontSize: "1rem",
      lineHeight: "1.3",
      whiteSpace: "normal",
    },
  },
}));

